import { createSelector } from 'reselect'

export const getGroupCategories = createSelector(
  (state) => state && state.categories && state.categories.groupCategories && Array.isArray(state.categories.groupCategories)
    ? state.categories.groupCategories
    : [],
  (groupCategories) => groupCategories
)
